import antdIT from 'antd/lib/locale-provider/it_IT';
import itMessages from '../locales/it_IT.json';

const itLang = {
    messages: itMessages,
    antd: antdIT,
    locale: 'it-IT',
};
export default itLang;
